import { useEffect, useState } from "react";
import { useLanguage } from "../../context/LanguageContext";

export const useGlossaryItems = () => {
  const { language } = useLanguage();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const loadGlossary = async () => {
      try {
        const mod = await import(`../translations/${language}-glossaryItems.js`);
        setItems(mod.glossaryItems ?? []);
      } catch (err) {
        console.warn(`Glossary not found for "${language}", falling back to English.`);
        const fallback = await import(`../translations/en-glossaryItems.js`);
        setItems(fallback.glossaryItems ?? []);
      }
    };

    loadGlossary();
  }, [language]);

  return items;
};
